// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { ErrorApiDefaultMessage } from "@vanmeter/XDL/constants";
import { FeaturedBrandsModule, FeaturedBrandsParameter } from "@vanmeter/XDL/types";

const brandsUri = "/api/vmi/brands/featuredBrands";

export async function getFeaturedBrands(
    parameters?: FeaturedBrandsParameter,
): Promise<ServiceResult<FeaturedBrandsModule[]>> {
    try {
        const res = await get<
            {
                detailPagePath: string;
                name: string;
                logoAltText: string;
                logoSmallImagePath: string;
                logoLargeImagePath: string;
                htmlContent?: string;
                metaDescription?: string;
            }[]
        >(brandsUri, parameters as any);
        const mapped: FeaturedBrandsModule[] = res.map(item => ({
            // mapping Data to be proper with mappedLink needed props
            url: item.detailPagePath,
            title: item.name,
            excludeFromNavigation: false,
            featuredImageAltText: item.logoAltText,
            featuredImagePath: item.logoSmallImagePath,
            logoLargeImagePath: item.logoLargeImagePath,
            logoSmallImagePath: item.logoSmallImagePath,
            htmlContent: item?.htmlContent || "",
            metaDescription: item?.metaDescription || "",
        }));
        return {
            result: mapped,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error?.errorJson?.message || error?.message || ErrorApiDefaultMessage,
        };
    }
}
